export const INITIAL_FORM_DATA = {
    name: '',
    description: '',
    enabled: true,
    triggerType: '',
    eventID: '',
    action: {
        actionType: 'Email',
        emailAddress: null,
        subject: '',
        body: '',
        htmlBody: false,
        httpMethod: 'POST',
        uri: '',
        headers: null,
    },
    companyID: '',
    companyName: '',
    partnerID: '',
    partnerName: '',
    wholesalerID: '',
    wholesalerName: '',
    isDeleted: false,
    latestFiredAt: null,
    triggerHistory: [],
    maximumScope: null,
};

export const FORM_FIELD_PATHS = {
    NAME: 'name',
    DESCRIPTION: 'description',
    ENABLED: 'enabled',
    TRIGGER_TYPE: 'triggerType',
    EVENT: 'event',
    EVENT_ID: 'eventID',
    COMPANY_ID: 'companyID',
    PARTNER_ID: 'partnerID',
    WHOLESALER_ID: 'wholesalerID',
    ACTION_TYPE: 'action.actionType',
    EMAIL_ADDRESS: 'action.emailAddress',
    SUBJECT: 'action.subject',
    BODY: 'action.body',
    HTML_BODY: 'action.htmlBody',
    HTTP_METHOD: 'action.httpMethod',
    URI: 'action.uri',
};

// The scope that owns each trigger type. A trigger type can only be pointed at
// another entity from a scope above it, so a Partner Admin creating a Partner
// trigger has exactly one possible target: its own partner.
const TRIGGER_TYPE_SCOPE = {
    Company: 20,
    Partner: 40,
    Wholesaler: 60,
};

/**
 * Whether the form shows an entity picker for the selected trigger type.
 *
 * Also gates the entity list queries: without this a Partner Admin fired a
 * list-all-partners request for a dropdown that was never rendered, and the
 * request is rejected at that scope (2930).
 */
export const showsEntityDropdown = (triggerType, requiredScope) => {
    const ownScope = TRIGGER_TYPE_SCOPE[triggerType];
    return Boolean(ownScope) && requiredScope > ownScope;
};
